export enum JobPositionFeatureDomain {
  JobBoard = 'JobBoard',
  JobListings = 'JobListings',
  Email = 'Email',
}
